import { loadDashboardAPI } from '@/service';
import { useQuery } from '@tanstack/react-query';
import { DashboardDTO, DashboardLoadRequest } from '@/model';
import { GenericPostResponse } from '@/type';
import { queryClient } from '@configuration/queryClient.config';

const dashboardBaseQueryKey = ['dashboard'];

export const dashboardQueryKey = (filters?: DashboardLoadRequest) => [
  ...dashboardBaseQueryKey,
  filters,
];
export const dashboardQueryFetchFunction = (filters?: DashboardLoadRequest) =>
  loadDashboardAPI(filters);

export const useLoadDashboardQuery = (filters?: DashboardLoadRequest) => {
  return useQuery<GenericPostResponse<DashboardDTO>>({
    queryKey: dashboardQueryKey(filters),
    queryFn: () => dashboardQueryFetchFunction(filters),
  });
};

export const invalidateDashboardQueryKey = () => {
  return queryClient.invalidateQueries({
    queryKey: dashboardBaseQueryKey,
  });
};
